import { useContext } from 'react';
import './styles.less'
import { DeleteFilled, EditOutlined } from "@ant-design/icons"
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import { firstLetterToUppercase } from 'src/utils/Functions';

export const AskForDraw = ({ close = () => { } }) => {
	const { translations } = useContext(ConfigStateContext);
    const path = 'M 32.341956,33.552161 C 46.87108,43.99802 28.616536,67.355415 31.984616,79.047691 35.176787,90.1293 46.606152,93.212308 61.227691,93.66923 75.84923,94.126152 70.435642,83.938846 80.41846,73.564614 92.114247,64.86204 112.66186,73.772364 109.66154,53.290382 107.18015,39.546477 91.841538,34.726155 82.703076,40.209231 73.564614,45.692308 66.253846,39.295384 65.796921,29.7 65.339999,20.104615 50.261538,26.044615 45.235383,28.329231'

    return <div className="mapAskForDraw">
        <div className="mapAskForDraw_content">
            <h5 className='text-center'>
                {firstLetterToUppercase(translations.busca)} una ubicación o {translations.dibuja} en el mapa <br /> para ver resultados más precisos
            </h5>

            <svg viewBox="0 0 52.916668 46.78064" preserveAspectRatio="none" className="mapDrawSvg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  >
                <g transform="matrix(0.67271126,0,0,0.67271126,-21.141569,-16.330667)">
                    <path x="0" y="0" className="mapDrawSvgPath" fill="none" strokeWidth="2" d={path} />
                    <path x="0" y="0" className="mapDrawSvgDashed" fill="none" stroke="white" strokeWidth="4" d={path} />
                </g>
            </svg>

            <button className="button button-primary" onClick={close}>Continuar</button>

        </div>
    </div>
}


export const DrawBtn = ({ drawing = false, action = () => { }, floating = true, polygon = null, actionClearMap = (val) => { }, }) => {

    return <div className='mapBtnContainer'>
        {polygon ? <button className={`mapBtn button button-primary ${floating ? 'floating' : ''} `}
            onClick={() => actionClearMap(false)} >
            <DeleteFilled />
            <span>{"Eliminar Dibujo"}</span>
        </button> : <button className={`mapBtn button ${drawing ? 'button-secondary ' : 'button-primary '} ${floating ? 'floating' : ''} `}
            onClick={action} >
            <EditOutlined />
            <span>{drawing ? "Terminar de dibujar" : "Dibujar en el mapa"}</span>
        </button>
        }
    </div >
}